import { Spin } from 'antd'

type ILoadingModal = {
    children: JSX.Element,
    isLoading: boolean,
    style?: React.CSSProperties
}

const LoadingModalComponent = ({ children, isLoading, style = { height: '100vh' } }: ILoadingModal) => {

    return (
        <>
            <Spin spinning={isLoading} size="default" tip="Loading..." style={style} >
                {children}
            </Spin>
        </>

    )
}

export default LoadingModalComponent